import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import {
  EmailInput,
  TextInput,
  PasswordInput,
  SelectInput,
  PhoneNumberInput,
  CountrySelectInput,
  RadioButton,
} from './components';
import './styles.css';

export interface IFormCompProps {
  fields?: any;
  initialData?: any;
  isPasswordField?: boolean;
  submitButtonLabel?: string;
  onFormSubmit?(payload: any): void;
  renderSubmitButton?(): void;
  labelColor?: string;
  employeetype?: any;
  isOwner?: boolean;
}

export const FormComp = (props: IFormCompProps) => {
  const {
    isPasswordField,
    fields,
    initialData,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
    isOwner,
    employeetype,
  } = props;
  const [formData, updateFormData] = useState<any>(initialData ?? {});
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [passwordErr, setPasswordErr] = useState<any>(false);
  const [mailErr, setmailErr] = useState<any>(false);
  const [phoneErrorData, setPhoneError] = useState<any>(0);
  const [localphoneErrorData, setlocalPhoneError] = useState<any>(0);
  console.log('passwordErr,', passwordErr, formData[fields?.password?.id]);
  console.log("Asirformdata", formData);
  const _renderSubmitButton = () => {
    if (renderSubmitButton) {
      return renderSubmitButton();
    }
    return (
      <div className="mt-3">
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '50%',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    const isValid = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();
    let hasError = false;
    const errorsObj: any = {};

    if (isOwner && !formData['userType']) {
      errorsObj['userType'] = true;
      hasError = true;
    } else {
      hasError = false;
    }

    if (!isOwner && formData[fields?.nationality?.id] === undefined) {
      errorsObj[fields?.nationality?.id] = true;
      hasError = true;
    }

    if (!isOwner && formData[fields?.citizenship?.id] === undefined) {
      errorsObj[fields?.citizenship?.id] = true;
      hasError = true;
    }

    if (isPasswordField && formData[fields?.confirmPassword?.id] === undefined) {
      errorsObj[fields?.confirmPassword?.id] = true;
      hasError = true;
    }

    if (isPasswordField && formData[fields?.password?.id] !== undefined) {
      const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\-]).{8,}$/;
      if (!regex.test(formData[fields?.password?.id])) {
        console.log('Password does not match the regex pattern.');
        setPasswordErr(true);
        errorsObj[fields?.password?.id] = true;
        hasError = true;
      }
    }
    if (
      (fields?.phoneNumber?.required && !formData[fields?.phoneNumber?.id]) ||
      formData[fields?.phoneNumber?.id]?.length < Number(phoneErrorData)
    ) {
      errorsObj[fields?.phoneNumber?.id] = true;
      hasError = true;
    }
    if (
      (fields?.localContactNo?.required && !formData[fields?.localContactNo?.id]) ||
      formData[fields?.localContactNo?.id]?.length < Number(localphoneErrorData)
    ) {
      errorsObj[fields?.localContactNo?.id] = true;
      hasError = true;
    }
    if (
      isPasswordField &&
      formData[fields?.password?.id] &&
      formData[fields?.confirmPassword?.id]
    ) {
      if (formData[fields?.password?.id]?.length < 8) {
        console.log('password length < 8');
        console.log('li->');

        errorsObj[fields?.password?.id] = true;
        hasError = true;
      }
      if (formData[fields?.password?.id] !== formData[fields?.confirmPassword?.id]) {
        console.log('password and confirm password does not match');
        errorsObj[fields?.confirmPassword?.id] = true;
        console.log('li->');

        hasError = true;
      }
    }
    
    const isLastNameExistId = fields?.isLastNameExist?.id;
    const lastNameId = fields?.lastName?.id;
    if (!formData[isLastNameExistId] || (formData[isLastNameExistId] !== 'yes' && formData[isLastNameExistId] !== 'no')) {
      errorsObj[isLastNameExistId] = true;
      hasError = true;
    } else if (formData[isLastNameExistId] === 'yes' && !formData[lastNameId]) {
      errorsObj[lastNameId] = true;
      hasError = true;
    }

    console.log('li->', hasError, isValid);
    setValidated(true);
    if (!hasError && isValid) {
      setErrors({});
      console.log('formData', formData);

      onFormSubmit && onFormSubmit(formData);
    } else {
      console.log('suspect->signup', errorsObj);
      window?.scrollTo(0, 0);
      setErrors(errorsObj);
    }
  };
  console.log(
    'errors[fields?.password?.id]',
    errors[fields?.password?.id] === true
      ? passwordErr
        ? fields?.password?.errorText1
        : fields?.password?.errorText
      : fields?.password?.errorText
  );

  const handleCompChange = (id: string, payload: any, errorData?: any) => {
    if (id && payload && errors[id] && payload !== '') {
      delete errors[id];
    }
    console.log(id, payload);
    if (id === 'phoneNumber') setPhoneError(errorData);
    if (id === 'localContactNo') setlocalPhoneError(errorData);

    const updatedFormData = {
      ...formData,
      [id]: payload,
    };
    if (id === 'isLastNameExist' && payload === 'no') {
      updatedFormData[fields?.lastName?.id] = null;
    }
  
    updateFormData(updatedFormData)
  };

  const _renderLayout = () => {
    console.log(formData);
    return (
      <Row key={`layout-1-row-default-layout`}>
        {isOwner && (
          <Col key={`layout-1-columns-orgName`} sm={12} className="mb-0">
            <TextInput
              {...fields?.orgName}
              value={initialData?.orgName}
              onCompChange={handleCompChange}
            />
          </Col>
        )}

        {isOwner && employeetype !== 'roe' && (
          <Col key={`layout-1-columns-userType`} sm={12} className="mb-0">
            <SelectInput
              id={'userType'}
              label={'User Type'}
              required={true}
              hasError={!!errors['userType']}
              errorText={'This field is required'}
              options={[
                {
                  id: 'owner',
                  label: 'Owner',
                },
                {
                  id: 'admin',
                  label: 'Admin',
                },
                {
                  id: 'agent',
                  label: 'HR Agent',
                },
              ]}
              onCompChange={handleCompChange}
              value={initialData?.userType}
            />
          </Col>
        )}
        {employeetype === 'roe' && (
          <Col key={`layout-1-columns-userType`} sm={12} className="mb-0">
            <SelectInput
              id={'userType'}
              label={'User Type'}
              required={true}
              hasError={!!errors['userType']}
              errorText={'This field is required'}
              options={[
                {
                  id: 'owner',
                  label: 'Owner',
                },
                {
                  id: 'admin',
                  label: 'Admin',
                },
                {
                  id: 'agent',
                  label: 'HR Agent',
                },
              ]}
              value={initialData?.userType}
              onCompChange={handleCompChange}
            />
          </Col>
        )}
        <Col key={`layout-1-columns-isLastNameExist`} sm={12} className="mb-0">
          <RadioButton
            {...fields?.isLastNameExist}
            onCompChange={handleCompChange}
            value={formData[fields?.isLastNameExist?.id]}
            hasError={!!errors[fields?.isLastNameExist?.id]}
          />
        </Col>
        {formData[fields?.isLastNameExist?.id] === 'yes' && (
          <Col key={`layout-1-columns-lastName`} sm={12} className="mb-0">
            <TextInput
              {...fields?.lastName}
              value={initialData?.lastName}
              onCompChange={handleCompChange}
              hasError={!!errors[fields?.lastName?.id]}
              errorText={fields?.lastName?.errorText}
            />
          </Col>
        )}
        <Col key={`layout-1-columns-firstName`} sm={12} className="mb-0">
          <TextInput
            {...fields?.firstName}
            value={initialData?.firstName}
            onCompChange={handleCompChange}
          />
        </Col>
        {
          <Col key={`layout-1-columns-trn`} sm={12} className="mb-0">
            <TextInput
              {...fields?.trn}
              value={initialData?.trn}
              onCompChange={handleCompChange}
            />
          </Col>
        }
        {!isOwner && (
          <Col key={`layout-1-columns-nationality`} sm={12} className="mb-0">
            <CountrySelectInput
              {...fields?.nationality}
              value={initialData?.nationality}
              onCompChange={handleCompChange}
              hasError={!!errors[fields?.nationality?.id]}
              errorText={'This field is required'}
            />
          </Col>
        )}
        {!isOwner && (
          <Col key={`layout-1-columns-citizenship`} sm={12} className="mb-0">
            <CountrySelectInput
              {...fields?.citizenship}
              value={initialData?.citizenship}
              onCompChange={handleCompChange}
              hasError={!!errors[fields?.citizenship?.id]}
              errorText={'This field is required'}
            />
          </Col>
        )}
        <Col key={`layout-1-columns-phoneNumber`} sm={12} className="mb-0">
          <PhoneNumberInput
            {...fields?.phoneNumber}
            value={initialData?.phoneNumber}
            onCompChange={handleCompChange}
            hasError={!!errors[fields?.phoneNumber?.id]}
            errorText={'This field is required'}
          />
        </Col>
        <Col key={`layout-1-columns-localContactNo`} sm={12} className="mb-0">
          <PhoneNumberInput
            {...fields?.localContactNo}
            value={initialData?.localContactNo}
            onCompChange={handleCompChange}
            isJamaican={true}
            hasError={!!errors[fields?.localContactNo?.id]}
            errorText={'This field is required'}
          />
        </Col>

        {isPasswordField && (
          <>
            <Col key={`layout-1-columns-password`} sm={12} className="mb-0">
              <PasswordInput
                {...fields?.password}
                value={initialData?.password}
                onCompChange={handleCompChange}
                hasError={!!errors[fields?.password?.id]}
                errorText={
                  errors[fields?.password?.id] === true
                    ? passwordErr
                      ? fields?.password?.errorText1
                      : fields?.password?.errorText
                    : fields?.password?.errorText
                }
              />
            </Col>
            <Col
              key={`layout-1-columns-confirm-password`}
              sm={12}
              className="mb-3"
            >
              <PasswordInput
                {...fields?.confirmPassword}
                value={initialData?.confirmPassword}
                onCompChange={handleCompChange}
                hasError={!!errors[fields?.confirmPassword?.id]}
                errorText={
                  formData[fields?.confirmPassword?.id] === undefined
                    ? fields?.confirmPassword?.errorText
                    : errors[fields?.confirmPassword?.id] === true
                    ? 'Your password and confirmation password must match'
                    : null
                }
              />
            </Col>
          </>
        )}
      </Row>
    );
  };

  return (
    <>
      <Form
        noValidate
        validated={validated}
        className="mt-4"
        onSubmit={handleSubmit}
      >
        <>
          {_renderLayout()}
          {_renderSubmitButton()}
        </>
      </Form>
    </>
  );
};

FormComp.defaultProps = {
  isPasswordField: false,
  fields: {
    email: {
      id: 'email',
      label: 'Email',
      required: true,
      placeholder: 'Enter your email address',
      errorText: 'Email is required',
      errorText1: 'Enter a valid Email',
      errorText2: 'Invalid email: either missing or a temporary email address',
      readOnly: false,
    },
    firstName: {
      id: 'firstName',
      label: 'First Name',
      required: true,
      placeholder: 'Enter your name',
      errorText: 'First Name is required',
      errorText1: 'First Name should be atleast 2 characters',
      pattern: `.{2,}`,
    },
    orgName: {
      id: 'orgName',
      label: 'Business Name',
      required: true,
      placeholder: 'Enter your Business name',
      errorText: 'Business Name is required',
      errorText1: 'Business Name should be atleast 5 characters',
    },
    trn: {
      id: 'trn',
      label: 'TRN',
      required: true,
      placeholder:
        'Enter your TRN , should not contain any special characters ex: 123456789',
      errorText: 'TRN is required',
      errorText1:
        'Invalid TRN. Must be 9 digits or 9 digits followed by / and 4 digits.',
      pattern: '^(\\d{9}|\\d{9}/\\d{4})$',
    },
    isLastNameExist: {
      id: 'isLastNameExist',
      label: 'Do you have a Last Name?',
      required: true,
      options: [
        {
          id: 'yes',
          label: 'Yes',
        },
        {
          id: 'no',
          label: 'No',
        },
      ],
      errorText: 'This field is required',
    },
    lastName: {
      id: 'lastName',
      label: 'Last Name',
      required: true,
      placeholder: 'Enter your last name',
      errorText: 'Last Name is required',
      errorText1: 'Last Name should be atleast 2 characters',
      pattern: `.{2,}`,
    },
    nationality: {
      id: 'nationality',
      label: 'Nationality',
      required: true,
      placeholder: 'Enter your Nationality',
      errorText: 'Nationality is required',
    },
    citizenship: {
      id: 'citizenship',
      label: 'Citizenship',
      required: true,
      placeholder: 'Enter your Citizenship',
      errorText: 'Citizenship is required',
    },
    phoneNumber: {
      id: 'phoneNumber',
      label: 'Mobile Number',
      required: true,
      placeholder:
        'Select your country code first and then Enter mobile number',
      // errorText: 'Phone Number is required',
    },
    localContactNo: {
      id: 'localContactNo',
      label: 'Local Jamaican Mobile Number',
      required: true,
      placeholder:
        'Select your country code first and then Enter mobile number',
      errorText: 'Local Jamaican Phone Number is required',
    },
    password: {
      id: 'password',
      label: 'Password',
      required: true,
      errorText: 'Password is required',
      pattern: `/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\-]).{8,}$/`,
      errorText1:
        'Password should contain min 8 characters,1 upper case,1 lower case, 1 number and 1 special character ',
      placeholder: 'Enter password',
    },
    confirmPassword: {
      id: 'confirmPassword',
      label: 'Confirm Password',
      required: true,
      errorText: 'Confirm Password is required',
      placeholder: 'Enter password again',
    },
  },
};
